import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import { Spin } from 'antd';

import config from '../../../config';

import './MealCustomization.less';
import MealOptionsSelector from './MealOptionsSelector';

const MealCustomization = forwardRef(({ selectedMeal: meal, onContinue, loading, customizations: mealChoices }, ref) => {
	const [customizations, setCustomizations] = useState({});
	const mealCustomizationRef = useRef(null);
	const requiredCustomizationIds = mealChoices.filter(choice => choice.is_required === true).map(item => item._id);

	const preselectedOption = meal?.chosen_meal_customizations ? meal?.chosen_meal_customizations.map(item => item) : [];
	const preselectedOptionIds = preselectedOption.map(option => option.selected_options._id);

	useEffect(() => {
		if (!preselectedOption.length) return;
		preselectedOption.forEach(item => {
			setCustomizations(state => ({ ...state, [item.customization_id]: { ...item.selected_options } }));
		});
	}, []);

	// check if all of the required is are in customizations or not
	const isDisabled = () => {
		let required = false;

		if (preselectedOptionIds.length) return false;

		requiredCustomizationIds.forEach(id => {
			if (!customizations[id]) {
				required = true;
				return;
			}
		});

		return required;
	};

	const [disabled, setDisabled] = useState(isDisabled());

	const handleOptionOnClick = (customizationId, selectedOptions) => {
		const updated = { ...customizations, [customizationId]: selectedOptions };
		setCustomizations(updated);
		const allRequiredSelected = requiredCustomizationIds.every(id => updated[id]);
		setDisabled(!allRequiredSelected);
	};

	const handleContinue = () => {
		const keys = [...Object.keys(customizations)];
		const customizedItems = [];
		keys.forEach(key => {
			customizedItems.push({
				customization_id: key,
				selected_options: customizations[key]
			});
		});

		meal.chosen_meal_customizations = customizedItems;
		onContinue(meal);
	};

	useImperativeHandle(ref, () => ({
		getCustomizations: () => {
			const keys = [...Object.keys(customizations)];
			const customizedItems = [];
			keys.forEach(key => {
				customizedItems.push({
					customization_id: key,
					selected_options: customizations[key]
				});
			});

			return customizedItems;
		}
	}));

	if (loading) {
		return (
			<div className="meal-customization-selector">
				<div className="meal-customization-loading">
					<Spin size="large" />
					<p>Loading available meal options...</p>
				</div>
			</div>
		);
	}

	if (meal) {
		let imageUrl = null;
		if (meal.asset && meal.asset.uuid && meal.asset.token) {
			imageUrl = `${config.api}/app/assets/id?uuid=${meal.asset.uuid}&token=${meal.asset.token}`;
		}


		return (
			<div className="meal-customization-selector">
				<div className="meal-customization-header">
					{
						imageUrl && (
							<img
								src={imageUrl}
								alt={meal.name}
								className="meal-customization-image"
								style={{ aspectRatio: '16/9', width: '100%', borderRadius: '8px', objectFit: 'cover' }}
							/>
						)
					}
					<div className="meal-customization-content">
						<div>
							<h2 className="meal-customization-title">{meal.meal_name}</h2>
							<p className="meal-customization-subtitle">Customize Your Meal</p>
						</div>
						<h2 className="meal-price">${meal.meal_price.toFixed(2)}</h2>
					</div>
				</div>

				<div className="meal-customization-list">
					<MealOptionsSelector
						options={mealChoices}
						ref={mealCustomizationRef}
						onClick={handleOptionOnClick}
						preselectedOptionIds={preselectedOptionIds}
					/>
				</div>

				<div className="meal-customization-footer">
					<button
						className="meal-customization-continue-btn"
						onClick={handleContinue}
						disabled={disabled} // disable when required option isnt selected
					>
						下一步 Continue
					</button>
				</div>

			</div>

		);
	}

});

export default MealCustomization;
